// Random positive messages for secret victories
// These replace the specific tutorial descriptions to make secret wins feel more special and surprising

export const SECRET_VICTORY_MESSAGES = [
  "Wow! You're really good at this!",
  "Amazing! You discovered something special!",
  "Incredible! You're a natural strategist!",
  "Outstanding! That was brilliant!",
  "Fantastic! You found the hidden path!",
  "Excellent! Your tactical skills are impressive!",
  "Superb! You mastered that perfectly!",
  "Brilliant! You exceeded all expectations!",
  "Magnificent! You're truly gifted at this!",
  "Spectacular! That was an expert-level move!"
];

/**
 * Get a random positive message for secret victories
 * Uses a deterministic approach based on tutorial info to ensure consistency within a session
 * but still provides variety across different secret victories
 */
export function getRandomSecretVictoryMessage(constellation: string, tutorialIndex: number): string {
  // Create a simple hash based on constellation and tutorial index
  // This ensures the same tutorial always gets the same message within a session,
  // but different tutorials get different messages
  const hash = constellation.length + tutorialIndex * 7;
  const messageIndex = ((hash % SECRET_VICTORY_MESSAGES.length) + SECRET_VICTORY_MESSAGES.length) % SECRET_VICTORY_MESSAGES.length;
  
  return SECRET_VICTORY_MESSAGES[messageIndex];
}

/**
 * Get a truly random secret victory message (different each time)
 * Use this version if you want complete randomness every time
 */
export function getRandomSecretVictoryMessageRandom(): string {
  const randomIndex = Math.floor(Math.random() * SECRET_VICTORY_MESSAGES.length);
  return SECRET_VICTORY_MESSAGES[randomIndex];
}

// Simple celebratory messages for regular victories
export const REGULAR_VICTORY_MESSAGES = [
  "You did it!",
  "Congratulations!",
  "Well done!",
  "Great job!",
  "Nice work!"
];

/**
 * Get a random simple celebration message for regular victories
 */
export function getRandomRegularVictoryMessage(): string {
  const randomIndex = Math.floor(Math.random() * REGULAR_VICTORY_MESSAGES.length);
  return REGULAR_VICTORY_MESSAGES[randomIndex];
}